import { render, staticRenderFns } from "./AcronymSearch.vue?vue&type=template&id=4c8056d9&scoped=true"
import script from "./AcronymSearch.vue?vue&type=script&lang=js"
export * from "./AcronymSearch.vue?vue&type=script&lang=js"
import style0 from "./AcronymSearch.vue?vue&type=style&index=0&id=4c8056d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8056d9",
  null
  
)

export default component.exports